import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b50f0cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ODetalhesUsuario",
  "data-testid": "ODetalhesUsuario"
}
const _hoisted_2 = { class: "ODetalhesUsuario__Responsabilidade" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ODetalhesUsuario__ResponsabilidadeTitulo" }, "projetos:", -1))
const _hoisted_4 = { class: "ODetalhesUsuario__ListaResponsabilidade" }
const _hoisted_5 = { class: "ODetalhesUsuario__Responsabilidade" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ODetalhesUsuario__ResponsabilidadeTitulo" }, " profissionais e usuários: ", -1))
const _hoisted_7 = { class: "ODetalhesUsuario__ListaUsuarios" }
const _hoisted_8 = { class: "ODetalhesUsuario__InformacoesPessoais" }
const _hoisted_9 = { class: "ODetalhesUsuario__NomeEmail" }
const _hoisted_10 = { class: "ODetalhesUsuario__Nome" }
const _hoisted_11 = { class: "ODetalhesUsuario__Email" }
const _hoisted_12 = { class: "ODetalhesUsuario__Responsabilidade" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ODetalhesUsuario__ResponsabilidadeTitulo" }, "recursos:", -1))
const _hoisted_14 = { class: "ODetalhesUsuario__ListaResponsabilidade" }

import ScrollPanel from "primevue/scrollpanel"
  import Avatar from "primevue/avatar"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"
  import { computed, onMounted, ref } from "vue"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { EntidadeGenerica } from "@/types/gerais"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"

  interface Props {
    idResponsavel: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODetalhesUsuario',
  props: {
    idResponsavel: null
  },
  setup(__props: any) {

const props = __props as {
    idResponsavel: string
  }

  

  const profissionais = ref<ListarProfissionais[]>([])
  const projetos = ref<EntidadeGenerica[]>([])
  const recursos = ref<EntidadeGenerica[]>([])
  const profissionaisRep = new ProfissionalRepositorio()
  const { pegarIniciais } = usarFuncoesStrings()
  const { leitor } = usarLeitorDeDados()

  const lerProfissionaisResponsaveis = leitor<
    ListarProfissionais,
    ParamsProfissional
  >(profissionaisRep.listarProfissionaisFrontend, {
    usuarios_responsaveis: `em.(${props.idResponsavel})`,
  })
  const estilizarLabelAvatar = (label: string, avatar: string | undefined) => {
    if (avatar === "@/assets/pi-avatar.png" || undefined) {
      return ""
    } else {
      return pegarIniciais(label)
    }
  }

  const estaCarregando = computed(() => {
    return lerProfissionaisResponsaveis.resultado.status === "pendente"
  })

  const limitarTamanhoNome = (nome: string) => {
    return nome.length > 37 ? nome.slice(0, 20) + "..." : nome
  }
  const listarProfissionaisPorResponsavel = async () => {
    await lerProfissionaisResponsaveis
      .porPagina(1000)
      .pagina(lerProfissionaisResponsaveis.primeiraPagina)
      .executar()

    if (lerProfissionaisResponsaveis.resultado.status === "sucesso") {
      profissionais.value = lerProfissionaisResponsaveis.resultado.dados
    }
  }
  onMounted(() => {
    listarProfissionaisPorResponsavel()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(ScrollPanel), { class: "ODetalhesUsuario__ScrollPanelResponsabilidade" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projetos.value, (projeto) => {
              return (_openBlock(), _createElementBlock("li", {
                key: projeto.id
              }, _toDisplayString(projeto.nome), 1))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_unref(estaCarregando))
        ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
        : (_openBlock(), _createBlock(_unref(ScrollPanel), {
            key: 1,
            class: "ODetalhesUsuario__ScrollPanelResponsabilidade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profissionais.value, (profissional) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: profissional.id
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(Avatar), {
                        class: "ODetalhesUsuario__Avatar",
                        image: profissional.urlFotoDeAvatar,
                        label: 
                  estilizarLabelAvatar(
                    profissional.nome,
                    profissional.urlFotoDeAvatar
                  )
                ,
                        shape: "circle"
                      }, null, 8, ["image", "label"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(limitarTamanhoNome(profissional.nome)), 1),
                        _createElementVNode("small", _hoisted_11, _toDisplayString(profissional?.usuarioRelacionado?.email), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_unref(ScrollPanel), { class: "ODetalhesUsuario__ScrollPanelResponsabilidade" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recursos.value, (recurso) => {
              return (_openBlock(), _createElementBlock("li", {
                key: recurso.id
              }, _toDisplayString(recurso.nome), 1))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})